import { createMediaQuery } from 'style-utils/core/createExtractCssFromProps/utils/createMediaQuery';
import {
  defaultBreakpoints,
  noBreakpoint,
} from 'style-utils/responsive-utils/media/media';
import { CSSObject } from 'styled-components';
import { getNestedPropertyOrDefault } from 'style-utils/core/createExtractCssFromProps/utils/getNestedPropertyOrDefault';

const breakpointKeys = [noBreakpoint, ...Object.keys(defaultBreakpoints)];

export const responsive = (styles: CSSObject) => (theme: object) => {
  const styleObject: Record<string, string | object> = {};
  const breakpoints = getNestedPropertyOrDefault(
    theme,
    'breakpoints',
    defaultBreakpoints,
  );
  for (const key in styles) {
    const value =
      typeof styles[key] === 'function'
        ? //theoretically we could pass a function that returns an object
          //but we put any because we don't want to deal with that
          (styles[key] as any)(theme)
        : styles[key];

    if (value == null) continue;

    if (!(typeof value === 'object')) {
      styleObject[key] = value;
      continue;
    }
    //if we enter here value is an object but it could be :
    //a responsive property object es: margin:{_:"1rem", desktop:"2rem"}
    //or a css object es: ":hover":{color:"red"}
    //so we need to do the appropriate checks

    //es {_:"1rem",desktop:"2.5rem"}
    const isBreakpointObject = Object.keys(value).every((key) =>
      breakpointKeys.includes(key),
    );

    //es {color:"orange"}
    if (!isBreakpointObject) {
      styleObject[key] = value;
      continue;
    }

    for (const breakpointKey in value) {
      const breakpoint = breakpoints[breakpointKey as keyof typeof breakpoints];
      const breakpointValue = value[breakpointKey as keyof typeof value];
      if (!breakpoint) {
        styleObject[key] = breakpointValue;
      } else {
        const media = createMediaQuery(breakpoint);
        styleObject[media] = styleObject[media] || {};
        (styleObject[media] as any)[key] = breakpointValue;
      }
    }
  }

  return styleObject;
};
